import constants from '../constants'

export const deeplinks = {
  [constants.CARE_PROGRAM_TYPE.ANAYA]:
    'https://mytatva.onelink.me/zXaX/8ytf92eh',
  'bilypsa-care': 'https://mytatva.onelink.me/zXaX/azvtrbq4',
  'prostate-care': 'https://mytatva.onelink.me/zXaX/c5eu0aq1',
  'akumentis-care': 'https://mytatva.onelink.me/zXaX/vacqqlx4',
}

export const programNames = {
  [constants.CARE_PROGRAM_TYPE.ANAYA]: 'Anaya Care Program',
  [constants.CARE_PROGRAM_TYPE.BILYPSA]: 'Ayushman Liver Care Program',
  [constants.CARE_PROGRAM_TYPE.PROSTATE]: 'Prostate Care Program',
  [constants.CARE_PROGRAM_TYPE.AKUMENTIS]: 'Akumentis Care Program',
}

export const loadingTexts = [
  'Loading... Did you know laughter is the best medicine? Loading your dose now!',
  'Loading... Why did the doctor carry a red pen? In case they needed to draw blood.',
  "Loading... Like waiting for chai to reach the perfect level of 'kadak'.",
  'Loading... Just like waiting for the Mumbai local during rush hour!',
  "Loading... Like waiting for the perfect 'pakora' to crisp up!",
  "Loading... Just like waiting for the doctor's appointment in a busy  hospital.",
  'Loading... Did you know? Yoga originated in ancient India over 5,000 years ago. Take a deep breath while we load!',
  "Loading... Why did the stethoscope join social media? To get more 'heart' reactions!",
  "Loading... Like waiting for the 'pani puri' vendor to serve up a healthy dose of deliciousness!",
  'Loading... Just like waiting for your chai to cool down enough to avoid burning your tongue!',
  "Loading... Like waiting for your 'desi nuskha' to kick in, but with digital delays!",
]

export const STATE_PAGE_SIZE = 60
export const OTHER_PAGE_SIZE = 20
